// Performance Optimization for Core Web Vitals
export const optimizePerformance = () => {
  // Only run in browser
  if (typeof window === 'undefined') return;

  // Preload critical resources
  const preloadLinks = [
    '/logo-rhelmu.png',
    '/rhelmu-banner.png'
  ];

  preloadLinks.forEach(href => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = href;
    document.head.appendChild(link);
  });

  // Lazy load images
  const images = document.querySelectorAll('img[data-src]');
  const imageObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.classList.remove('lazy');
        observer.unobserve(img);
      }
    });
  });

  images.forEach(img => imageObserver.observe(img));
};

// Optimize fonts loading
export const optimizeFonts = () => {
  // Only run in browser
  if (typeof window === 'undefined') return;

  // Preconnect to Google Fonts
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnect);

  const preconnect2 = document.createElement('link');
  preconnect2.rel = 'preconnect';
  preconnect2.href = 'https://fonts.gstatic.com';
  preconnect2.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect2);
};

// Optimize CSS delivery
export const optimizeCSS = () => {
  // Only run in browser
  if (typeof window === 'undefined') return;

  // Inline critical CSS
  const criticalCSS = `
    .critical-styles {
      font-family: 'Quicksand', sans-serif;
      color: #1B65A6;
    }
  `;
  
  const style = document.createElement('style');
  style.textContent = criticalCSS;
  document.head.appendChild(style);
};

// Optimize JavaScript loading
export const optimizeJavaScript = () => {
  // Only run in browser
  if (typeof window === 'undefined') return;

  // Defer non-critical JavaScript
  const scripts = document.querySelectorAll('script[data-defer]');
  scripts.forEach(script => {
    script.defer = true;
  });
};

// Monitor Core Web Vitals (Native implementation)
export const monitorCoreWebVitals = () => {
  // Only run in browser
  if (typeof window === 'undefined') return;

  // Monitor Largest Contentful Paint (LCP)
  if ('PerformanceObserver' in window) {
    try {
      const lcpObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const lastEntry = entries[entries.length - 1];
        console.log('LCP:', lastEntry.startTime);
      });
      lcpObserver.observe({ entryTypes: ['largest-contentful-paint'] });
    } catch (e) {
      console.log('LCP monitoring not supported');
    }

    // Monitor First Input Delay (FID)
    try {
      const fidObserver = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          console.log('FID:', entry.processingStart - entry.startTime);
        });
      });
      fidObserver.observe({ entryTypes: ['first-input'] });
    } catch (e) {
      console.log('FID monitoring not supported');
    }

    // Monitor Cumulative Layout Shift (CLS)
    try {
      let clsValue = 0;
      const clsObserver = new PerformanceObserver((list) => {
        for (const entry of list.getEntries()) {
          if (!entry.hadRecentInput) {
            clsValue += entry.value;
          }
        }
        console.log('CLS:', clsValue);
      });
      clsObserver.observe({ entryTypes: ['layout-shift'] });
    } catch (e) {
      console.log('CLS monitoring not supported');
    }
  }
};

// Optimize images
export const optimizeImages = () => {
  // Only run in browser
  if (typeof window === 'undefined') return;

  const images = document.querySelectorAll('img');
  images.forEach(img => {
    // Add loading="lazy" to non-critical images
    if (!img.classList.contains('critical')) {
      img.loading = 'lazy';
    }
    
    // Add alt text if missing
    if (!img.alt) {
      img.alt = 'RHELMU - Sistema de Gestión Dental';
    }
  });
};

// Initialize all optimizations
export const initPerformanceOptimizations = () => {
  // Only run in browser
  if (typeof window === 'undefined') return;

  optimizeFonts();
  optimizeCSS();
  optimizeJavaScript();
  optimizeImages();
  monitorCoreWebVitals();
};